import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { SiteSettingsContext } from './PublicLayout';
import { MapPin, Briefcase, ArrowRight, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicCareers() {
  const settings = useContext(SiteSettingsContext) || {};
  const primary = settings.primary_color || '#1a3a5c';
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/job-positions`).then(r => setJobs(r.data)).catch(() => setJobs([]));
  }, []);

  return (
    <div>
      <section className="border-b" style={{ background: `linear-gradient(135deg, ${primary} 0%, ${primary}cc 100%)` }}>
        <div className="max-w-6xl mx-auto px-4 py-14 text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-3" data-testid="careers-heading">Careers</h1>
          <p className="text-lg opacity-90 max-w-2xl">{settings.careers_blurb}</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 py-12">
        {jobs === null ? (
          <div className="flex items-center justify-center py-12 text-muted-foreground">
            <Loader2 className="animate-spin mr-2" size={18} /> Loading open positions…
          </div>
        ) : jobs.length === 0 ? (
          <div className="text-center py-12 text-muted-foreground">
            <p className="text-lg">No positions open at the moment — check back soon!</p>
            <p className="text-sm mt-2">
              Want to be notified? <a className="underline" href={`mailto:${settings.contact_email || ''}`}>Email us</a>.
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground mb-2" data-testid="careers-count">
              {jobs.length} open position{jobs.length === 1 ? '' : 's'}
            </p>
            {jobs.map(job => (
              <Link
                key={job.id}
                to={`/careers/apply/${job.id}`}
                className="block rounded-lg border bg-white p-5 hover:shadow-md hover:border-primary/40 transition-all group"
                data-testid={`job-card-${job.id}`}
              >
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-lg group-hover:text-primary transition-colors" style={{ color: primary }}>
                      {job.title}
                    </h3>
                    <div className="flex items-center gap-4 text-sm text-muted-foreground mt-1 flex-wrap">
                      {job.discipline && (
                        <span className="inline-flex items-center gap-1"><Briefcase size={13} /> {job.discipline}</span>
                      )}
                      {job.location && (
                        <span className="inline-flex items-center gap-1"><MapPin size={13} /> {job.location}</span>
                      )}
                      {job.employment_type && (
                        <span className="inline-flex items-center gap-1 text-xs bg-muted px-2 py-0.5 rounded">
                          {job.employment_type}
                        </span>
                      )}
                    </div>
                    {job.summary && <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{job.summary}</p>}
                  </div>
                  <ArrowRight size={18} className="text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all shrink-0" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
